import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	::-webkit-scrollbar {
		display: none; /* Oculta a barra de rolagem */
	}
`;

export const centralize = styled.div`
	width: 100%;
	padding: 8px 8px 0 8px;
	display: flex;
	align-items: flex-start;
	justify-content: center;
`;

export const boxApp = styled.div`
	width: 100%;
	background-color: ${color.interface.white};
	border-radius: 5px;
	padding: 10px;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: center;
	justify-content: flex-start;
`;

export const date = styled.p`
	width: 100%;
	font-size: 1.4rem;
	text-align: left;

	color: ${color.interface.darkgray};
`;

export const img = styled.div`
	width: 100%;

	> img {
		width: 100%;
		background-color: ${color.interface.lightGray2};
		border-radius: 5px;
	}
`;

export const title = styled.p`
	font-family: nunito-bold;
	width: 100%;
	font-size: 1.5rem;
	text-align: left;
	color: ${color.interface.darkgray};
`;

export const subTitle = styled.p`
	width: 100%;
	font-family: nunito-bold;
	font-size: 1.2rem;
	color: ${color.interface.darkgray};
`;

export const description = styled.p`
	width: 100%;
	font-size: 1.2rem;
	color: ${color.interface.darkgray};
	box-sizing: content-box;
	overflow: hidden;
`;

export const contentHTML = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	text-align: justify;
	overflow: hidden;

	img {
		max-width: 100%;
		height: auto;
	}
`;
